import { render } from "./SupplierInvoiceDetailsView.vue?vue&type=template&id=5b707327&scoped=true"
import script from "./SupplierInvoiceDetailsView.vue?vue&type=script&lang=js"
export * from "./SupplierInvoiceDetailsView.vue?vue&type=script&lang=js"

import "./SupplierInvoiceDetailsView.vue?vue&type=style&index=0&id=5b707327&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b707327"]])

export default __exports__